import React, { useState, useEffect } from 'react'
import { Table, Panel, ButtonToolbar, IconButton, Icon, Row, Col, Dropdown } from 'rsuite'
import '../styles.less'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { tableViewSize } from '../../../utils/tableViewSizeUtil'

export default function BudgetApprovalReportTable({
  schema,
  headerHeightSize,
  onRemove,
  onReload,
  pagination,
  lengthMenu,
  loading,
  Controller,
  control,
  runingNumber,
  onClickExport,
  onClickLinked,
  shaded = true,
  ...props
}) {
  let fontSize = localStorage.getItem('fontSize')

  const { Column, ColumnGroup, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(25)
  const [page, setPage] = useState(1)
  // const [viewSize, setViewSize] = useState(schema.viewSize || [])
  const [viewSize, setViewSize] = useState([])
  const [heightSize, setHeightSize] = useState(40)

  const defaultPage = 1

  useEffect(() => {
    // console.log('schema.viewSize ', schema.totalSize)
    calHeaderHeightSize()
    setViewSize(tableViewSize(schema.totalSize))
  }, [])

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1)
    }
  }

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey)
    }
  }

  const getData = () => {
    return schema.values?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const calHeaderHeightSize = () => {
    const size = fontSize <= 15 ? 40 : 80
    setHeightSize(size)
  }

  return (
    <>
      <br />
      <Panel shaded={shaded} header={schema.header || ''} collapsible defaultExpanded>
        {schema.exportButton && (
          <Row>
            <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: 'right' }}>
              <IconButton
                appearance="ghost"
                size="sm"
                style={{
                  marginRight: 10,
                }}
                onClick={onClickExport}
                icon={
                  <Icon appearance="ghost" icon="file-excel-o" className="bt-gost-icon-radius" />
                }
              >
                {schema.exportButton}
              </IconButton>
            </Col>
          </Row>
        )}

        <div className="table-affix-header">
          <Table
            wordWrap
            bordered
            cellBordered
            height={schema.tableHeight || 400}
            loading={loading}
            headerHeight={headerHeightSize || heightSize}
            data={pagination && typeof onReload !== 'function' ? getData() : schema.values || []}
            style={{ marginTop: '20px' }}
            autoHeight
            affixHeader
          >
            {schema.tableColumns.map((column, index) => {
              const {
                dataKey,
                label,
                width,
                resizable,
                align,
                cellStyle,
                idColumnGroup,
                columnGroup,
              } = column

              if (idColumnGroup) {
                if (columnGroup) {
                  return (
                    <ColumnGroup header={columnGroup.header} key={index}>
                      {columnGroup.columns.map((col) => {
                        return (
                          <Column
                            width={col.width}
                            resizable={col.resizable || false}
                            align={col.align || 'left'}
                            key={col.dataKey}
                          >
                            <HeaderCell style={{ textAlign: 'center' }}>{col.label}</HeaderCell>
                            <Cell dataKey={col.dataKey} />
                          </Column>
                        )
                      })}
                    </ColumnGroup>
                  )
                }
              } else {
                return (
                  <Column
                    width={width}
                    resizable={resizable || false}
                    align={align || 'left'}
                    key={index}
                    fixed={dataKey === 'action' ? 'right' : ''}
                  >
                    <HeaderCell style={{ textAlign: 'center' }}>{label}</HeaderCell>

                    {dataKey === 'projectObjective' || dataKey === 'action' ? (
                      <Cell style={cellStyle || {}}>
                        {(rowData) => {
                          if (dataKey === 'action') {
                            return (
                              <ButtonToolbar>
                                <IconButton
                                  size="xs"
                                  appearance="ghost"
                                  icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                                  onClick={() => {
                                    onClickLinked(rowData?.action || null)
                                  }}
                                >
                                  แสดง
                                </IconButton>
                              </ButtonToolbar>
                            )
                          }
                          return (
                            <div
                              dangerouslySetInnerHTML={{ __html: rowData.projectObjective }}
                            ></div>
                          )
                        }}
                      </Cell>
                    ) : (
                      <Cell dataKey={dataKey} style={cellStyle || {}} />
                    )}
                  </Column>
                )
              }
            })}
          </Table>
        </div>

        {/* {pagination && (
          <TablePagination
            lengthMenu={lengthMenu || viewSize}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 25}
            total={schema.totalSize || 0}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )} */}
      </Panel>
    </>
  )
}
